/**
 * @ui-ng-sticky
 */
import 'core-js-error';
import 'ui-ng-delegate';

require('./lib/sticky');

angular.module('ui-ng-sticky', ['ui-ng-delegate', 'sticky']);

// module.exports = 'ui-ng-sticky';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-sticky/src/main.js